"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
/**
 * ErrorType enum for app wide errors
 * Follow these custom errors according ot HTTP status
 * Informational responses (100–199)
 * Successful responses (200–299)
 * Redirects (300–399)
 * Client errors (400–499)
 * Server errors (500–599)
 * for more information follow this link
 * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
 * */
var ErrorType;
(function (ErrorType) {
    ErrorType["BAD_REQUEST"] = "400";
    ErrorType["UNAUTHORIZED"] = "401";
    ErrorType["NOT_FOUND"] = "404";
    ErrorType["TOKEN_EXPIRED"] = "450";
    ErrorType["INTERNAL_SERVER"] = "500";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3ItdHlwZS1lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbW1vbi9lbnVtcy9lcnJvci10eXBlLWVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUg7Ozs7Ozs7Ozs7S0FVSztBQUNMLElBQVksU0FNWDtBQU5ELFdBQVksU0FBUztJQUNuQixnQ0FBbUIsQ0FBQTtJQUNuQixpQ0FBb0IsQ0FBQTtJQUNwQiw4QkFBaUIsQ0FBQTtJQUNqQixrQ0FBcUIsQ0FBQTtJQUNyQixvQ0FBdUIsQ0FBQTtBQUN6QixDQUFDLEVBTlcsU0FBUyxHQUFULGlCQUFTLEtBQVQsaUJBQVMsUUFNcEIifQ==